import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllPartes = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/partes?clave=${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllPartesMutation: mutation.mutate,
    };
}